export const PHONE = "3382800207";
export const PHONE_LINK = "tel:+393382800207";
export const EMAIL = "edilkrea@gmail.com";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const INPUT_CLS =
  "w-full rounded-lg bg-card2 border border-gold/15 px-4 py-3 text-cream placeholder:text-slate-500 focus:outline-none focus:border-copper/60 focus:ring-1 focus:ring-copper/40 transition-colors";

export const MARQUEE_ITEMS = [
  "Ristrutturazioni Chiavi in Mano",
  "Impianti Elettrici & Idraulici",
  "Nuove Costruzioni",
  "Domotica & Smart Home",
  "Efficientamento Energetico",
  "Direzione Lavori Integrata",
];

export const SERVICES = [
  {
    id: "ristrutturazioni",
    title: "Ristrutturazioni Edili Chiavi in Mano",
    tag: "Edilizia Residenziale & Commerciale",
    description:
      "Riqualificazione completa di appartamenti, ville e locali commerciali con materiali di pregio e direzione lavori integrata. Un unico referente dalla demolizione alla consegna.",
    points: ["Demolizioni e ricostruzioni", "Finiture di pregio", "Pratiche edilizie incluse"],
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "impianti",
    title: "Impianti Tecnologici & Domotica",
    tag: "Impiantistica Avanzata",
    description:
      "Realizzazione di impianti elettrici, termoidraulici, climatizzazione smart e sistemi fotovoltaici ad alta efficienza. Tecnologia certificata al servizio del comfort.",
    points: ["Impianti elettrici certificati", "Domotica e smart home", "Fotovoltaico e pompe di calore"],
    image: "https://images.unsplash.com/photo-1622426385889-4fc93a72423a?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "costruzioni",
    title: "Nuove Costruzioni & Ingegneria",
    tag: "Ingegneria & Strutture",
    description:
      "Realizzazione ex-novo di edifici moderni in bioedilizia, cemento armato e strutture ad isolamento sismico avanzato. Dal terreno alle chiavi di casa.",
    points: ["Bioedilizia e cemento armato", "Isolamento sismico", "Progettazione strutturale"],
    image: "https://images.unsplash.com/photo-1558661091-5cc1b64d0dc5?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "energia",
    title: "Efficientamento Energetico",
    tag: "Sostenibilità & Ecobonus",
    description:
      "Cappotti termici, sostituzione infissi, pompe di calore e certificazioni energetiche per portare il tuo immobile in classe A4 e ridurre i consumi.",
    points: ["Cappotto termico", "Infissi ad alta efficienza", "Certificazione energetica APE"],
    image: "https://images.unsplash.com/photo-1600421495550-158936f5ecfa?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const PROJECTS = [
  {
    img: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Villa Vista Lago",
    cat: "Ristrutturazioni",
    loc: "Lago di Como",
    durata: "8 mesi",
    materiali: "Travertino, rovere naturale, vetro strutturale",
    desc: "Ristrutturazione chiavi in mano di villa anni '70 con nuova distribuzione degli spazi e finiture di lusso.",
  },
  {
    img: "https://images.unsplash.com/photo-1662445407335-db6b4e68c323?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Recupero Sottotetto",
    cat: "Ristrutturazioni",
    loc: "Milano",
    durata: "4 mesi",
    materiali: "Cartongesso, isolante in fibra di legno",
    desc: "Recupero abitativo di sottotetto con opere murarie, isolamento e nuove aperture.",
  },
  {
    img: "https://images.unsplash.com/photo-1747538454766-9f4f99a2de8f?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Cucina su Misura",
    cat: "Interni & Design",
    loc: "Monza",
    durata: "2 mesi",
    materiali: "Marmo, ottone brunito, laccato opaco",
    desc: "Cucina bespoke con isola centrale in marmo e illuminazione integrata.",
  },
  {
    img: "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Living in Travertino",
    cat: "Interni & Design",
    loc: "Bergamo",
    durata: "3 mesi",
    materiali: "Travertino romano, pietra levigata",
    desc: "Zona living rivestita in travertino con camino su misura e arredi integrati.",
  },
  {
    img: "https://images.pexels.com/photos/40211701/pexels-photo-40211701.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Scala Scenografica",
    cat: "Interni & Design",
    loc: "Como",
    durata: "6 settimane",
    materiali: "Marmo bianco, ringhiera in ferro battuto",
    desc: "Scala interna in marmo con struttura alleggerita e illuminazione a LED integrata.",
  },
  {
    img: "https://images.pexels.com/photos/18707955/pexels-photo-18707955.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Cucina Legno e Pietra",
    cat: "Interni & Design",
    loc: "Lecco",
    durata: "10 settimane",
    materiali: "Rovere massello, pietra sinterizzata",
    desc: "Cucina calda e materica con piano in pietra e boiserie in rovere.",
  },
  {
    img: "https://images.unsplash.com/photo-1622426385889-4fc93a72423a?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Quadro Elettrico Domotico",
    cat: "Impiantistica",
    loc: "Milano",
    durata: "2 settimane",
    materiali: "Componentistica KNX certificata",
    desc: "Realizzazione quadro elettrico domotico con gestione scenari e controllo remoto.",
  },
  {
    img: "https://images.unsplash.com/photo-1601997123254-a9f1ad6a756b?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Impianto Termoidraulico",
    cat: "Impiantistica",
    loc: "Brescia",
    durata: "3 settimane",
    materiali: "Multistrato, collettori a zone",
    desc: "Centrale termica e distribuzione idraulica a soffitto per loft industriale.",
  },
  {
    img: "https://images.unsplash.com/photo-1694521787149-ee0b6a3d9f78?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Controsoffitto Tecnico",
    cat: "Impiantistica",
    loc: "Sondrio",
    durata: "4 settimane",
    materiali: "Cartongesso tecnico, corpi illuminanti LED",
    desc: "Controsoffitto ispezionabile con integrazione di illuminazione e ventilazione.",
  },
  {
    img: "https://images.unsplash.com/photo-1558661091-5cc1b64d0dc5?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Residenza in Bioedilizia",
    cat: "Nuove Costruzioni",
    loc: "Varese",
    durata: "14 mesi",
    materiali: "Cemento armato, facciata ventilata",
    desc: "Nuova costruzione in classe A4 con facciata ventilata e isolamento sismico.",
  },
  {
    img: "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Villa Moderna Ex-Novo",
    cat: "Nuove Costruzioni",
    loc: "Lugano (CH)",
    durata: "16 mesi",
    materiali: "Vetro strutturale, cemento a vista",
    desc: "Villa di nuova costruzione con ampie vetrate e struttura in cemento a vista.",
  },
  {
    img: "https://images.unsplash.com/photo-1600421495550-158936f5ecfa?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: "Bagno Minimal in Resina",
    cat: "Interni & Design",
    loc: "Milano",
    durata: "5 settimane",
    materiali: "Resina spatolata, sanitari sospesi",
    desc: "Bagno minimal con rivestimento continuo in resina e doccia walk-in.",
  },
];

export const GALLERY_FILTERS = ["Tutti", "Ristrutturazioni", "Interni & Design", "Impiantistica", "Nuove Costruzioni"];
